import React from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';

import bahijB from '../../assets/fonts/Bahij-Nazanin-Bold.ttf';
export default function Table({ v }) {
    return (
        <View style={styles.tableContainer}>
            <InvoiceTableHeader v={v}/>
            <InvoiceTableRow v={v} />
        </View>
    )
}

const InvoiceTableHeader = ({v}) => {
    Font.register({ family: 'bahijB', src: bahijB });

    const borderColor = '#b2dfdb'
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'row',
            backgroundColor: '#840302',
            color: '#fff',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontFamily: 'bahijB',
            flexGrow: 1,
            fontSize: 10,
            lineHeight: 1.5,


        },
        no: {
            width: '10%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
            textAlign: 'center',


        },
        description: {
            width: '60%',
            borderRightColor: borderColor,
            borderRightWidth: 1,


        },
        amount: {
            width: '30%',
            borderRightWidth: 1,
            borderRightColor: borderColor,
        },
    });

    return (
        <View style={styles.container}>
            <Text style={styles.amount}>{v?.tariffType?.value !==96? `مبلغ )افغانی(`:`مبلغ )دالر امريکايی(`}</Text>
            <Text style={styles.description}>{`جنس`}</Text>
            <Text style={styles.no}>#</Text>
        </View>
    );
}


const InvoiceTableRow = ({ v }) => {
    const getSplitText = (t) => t ? t.split(" ") : []
    const cn = (n) => v?.com?.numConvertAndRevrse(n);
    const rd = (n) => v?.com?.reverseDigits(n);


    const reverseDigits =  (str)=> {
        const digits = str.match(/[\d۰-۹]/g);
        if (!digits) return str;
        digits.reverse();
        return str.replace(/[\d۰-۹]/g, () => digits.shift());
      }


    const borderColor = '#840302'
    const styles = StyleSheet.create({
        row: {
            flexDirection: 'row',
            borderBottomColor: '#840302',
            borderBottomWidth: 0.5,
            alignItems: 'center',
            margin: 0,
            fontSize: 9
        },
        no: {
            width: '10%',
            borderRightColor: borderColor,
            borderRightWidth: 0.5,
            paddingLeft: 8,
            paddingRight: 8,
            margin: 0,

        },
        description: {
            width: '60%',

            borderRightWidth: 0.5,
            paddingLeft: 8,
            paddingRight: 8,
            borderRightColor: borderColor,
        },

        amount: {
            width: '30%',
            textAlign: 'center',
            paddingRight: 8,
            borderRightWidth: 0.5,
            borderRightColor: borderColor,
        },

        flexRowReverse: {
            flexDirection: "row-reverse",
            lineHeight: 1.3,
            flexWrap: "wrap",
            borderRightColor: borderColor,
        },
        ml1: {
            marginLeft: "3pt",

        },

        rBorderColor: {
            borderRightColor: borderColor,
            width: '30%',
        },
        crossTotal: {

            borderRightWidth: 0.5,
            fontSize: 10,
            textAlign: 'center',
            borderRightColor: borderColor,
            borderTopColor: '#840302',
            borderTopWidth: 0.5,
        }
    });


    const rows = v?.items?.map((item, i) => {

        return (<View style={styles.row} key={i}>
            <Text style={styles.amount}> {cn(item.tariff_amount)}</Text>
            <View style={[styles.flexRowReverse, styles.description]}>
                {getSplitText(item?.category?.label ? item?.category?.label : item?.from_name).map((word, idx) => {
                    if (idx < 6)
                        return (
                            <Text style={{ ...styles.ml1 }} key={idx}>
                                {word}
                            </Text>
                        );
                })}
                : <Text style={{ ...styles.ml1 }}> {rd(item?.description)}</Text>

            </View>
            <Text style={styles.no} > {i + 1}</Text>
        </View>)
    })

    const grossRow = (
        <>
        {/* <View style={styles.row}>
            <Text style={{ ...styles.crossTotal, width: '30%' }} >؋ {cn(v?.tariffType?.value === 21 ? (v?.amount - 100) : Number(v?.amount))} </Text>
            <Text style={{ ...styles.crossTotal, width: '70%' }}>مجموع فرعی</Text>
        </View> */}
        {v?.tariffType?.value === 21&&   <View style={styles.row}>
            <Text style={{ ...styles.amount }} > {cn('100')} </Text>
            <Text style={{ ...styles.description,  }}>مصارف قرطاسيه</Text>
            <Text style={{ ...styles.no}}>{v?.items.length+1}</Text>
        </View>}
        <View style={styles.row}>
            <Text style={{ ...styles.crossTotal, width: '30%', fontWeight: 'bold', fontFamily: 'bahijB', }} > { cn(v?.amount)} </Text>
            <Text style={{ ...styles.crossTotal, width: '70%', fontWeight: 'bold', fontFamily: 'bahijB' }}>مبلغ قابل تاديه</Text>
        </View>
</>
        )
    const blankRows = Array(v?.items.length > 2 ? 0 : 2).fill(0)
    const emptyRows = blankRows.map((x, i) =>
        <View style={styles.row} key={`BR${i}`}>
            <Text style={styles.amount}>-</Text>
            <Text style={styles.description}>-</Text>
            <Text style={styles.no}>-</Text>

        </View>
    )
    return (<>{rows} {emptyRows} {grossRow}</>)
};

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 0.5,
        borderColor: '#840302',
    },

});
